class PreviousStepNotFound extends Error {}

export default PreviousStepNotFound;
